import { IIsiDtoPresentationLogicResponse } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IIsiDataTransferObject } from "./Isilog.IsiFramework.IsiDataTransferObject";
import { IsiDataTransferObject } from "./Isilog.IsiFramework.IsiDataTransferObject";
import { IsiDtoPresentationLogicResponse } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IIsiDtoPresentationLogicRequest } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IsiDtoPresentationLogicRequest } from "./Isilog.IsiComponent.IsiDataTransferObject";

export interface IIsiDtoPlRacResponse extends IIsiDtoPresentationLogicResponse  {
    result?: IIsiDtoPlRacResult;
}
export interface IIsiDtoPlRacResult extends IIsiDataTransferObject  {
    actionValue?: string;
    actionMode?: ActionModeType;
}
export enum ActionModeType {
    None = 0,
    LaunchRacBandeau = 1,
    ExecuteRaccourci = 2,
    DirectOpen = 3,
}
export class IsiDtoPlRacResult extends IsiDataTransferObject implements IIsiDtoPlRacResult {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.PresentationLogic.Rac.IsiDtoPlRacResult, Isilog.IsiComponent.IsiDataTransferObject";
    actionValue?: string;
    actionMode?: ActionModeType;

    constructor(data?: IIsiDtoPlRacResult) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.actionValue = _data["actionValue"] !== undefined ? _data["actionValue"] : <any>null;
            this.actionMode = _data["actionMode"] !== undefined ? _data["actionMode"] : ActionModeType.None;
        }
    }

    static fromJS(data?: IIsiDtoPlRacResult): IsiDtoPlRacResult {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlRacResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["actionValue"] = this.actionValue !== undefined ? this.actionValue : <any>null;
        data["actionMode"] = this.actionMode !== undefined ? this.actionMode : ActionModeType.None;
        return data;
    }
}
export class IsiDtoPlRacResponse extends IsiDtoPresentationLogicResponse implements IIsiDtoPlRacResponse {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.PresentationLogic.Rac.IsiDtoPlRacResponse, Isilog.IsiComponent.IsiDataTransferObject";
    result?: IsiDtoPlRacResult;

    constructor(data?: IIsiDtoPlRacResponse) {
        super(data);
        if (data) {
            this.result = data.result && !(<any>data.result).toJSON ? new IsiDtoPlRacResult(data.result) : <IsiDtoPlRacResult>this.result;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.result = _data["result"] ? IsiDtoPlRacResult.fromJS(_data["result"]) : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoPlRacResponse): IsiDtoPlRacResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlRacResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["result"] = this.result != null ? (<any>this.result).toJSON() : <any>null;
        return data;
    }
}
export interface IIsiDtoPlRacRequest extends IIsiDtoPresentationLogicRequest  {
    extendedNews?: boolean;
    requestedRacValue?: string;
    response?: IIsiDtoPlRacResponse;
}
export class IsiDtoPlRacRequest extends IsiDtoPresentationLogicRequest implements IIsiDtoPlRacRequest {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.PresentationLogic.Rac.IsiDtoPlRacRequest, Isilog.IsiComponent.IsiDataTransferObject";
    extendedNews?: boolean;
    requestedRacValue?: string;
    response?: IsiDtoPlRacResponse;

    constructor(data?: IIsiDtoPlRacRequest) {
        super(data);
        if (data) {
            this.response = data.response && !(<any>data.response).toJSON ? new IsiDtoPlRacResponse(data.response) : <IsiDtoPlRacResponse>this.response;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.extendedNews = _data["extendedNews"] !== undefined ? _data["extendedNews"] : false;
            this.requestedRacValue = _data["requestedRacValue"] !== undefined ? _data["requestedRacValue"] : <any>null;
            this.response = _data["response"] ? IsiDtoPlRacResponse.fromJS(_data["response"]) : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoPlRacRequest): IsiDtoPlRacRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlRacRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["extendedNews"] = this.extendedNews !== undefined ? this.extendedNews : false;
        data["requestedRacValue"] = this.requestedRacValue !== undefined ? this.requestedRacValue : <any>null;
        data["response"] = this.response != null ? (<any>this.response).toJSON() : <any>null;
        return data;
    }
}
